export default __webpack_public_path__ + "static/media/lamb_gray.ed45406e.svg";